module.exports = __webpack_public_path__ + "static/img/045 2.5fc99b01.jpg";